/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface IncomeTypeCreateUpdateRequestDto
 */
export interface IncomeTypeCreateUpdateRequestDto {
  /**
   *
   * @type {string}
   * @memberof IncomeTypeCreateUpdateRequestDto
   */
  name: string;
}

export function IncomeTypeCreateUpdateRequestDtoFromJSON(json: any): IncomeTypeCreateUpdateRequestDto {
  return IncomeTypeCreateUpdateRequestDtoFromJSONTyped(json, false);
}

export function IncomeTypeCreateUpdateRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IncomeTypeCreateUpdateRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
  };
}

export function IncomeTypeCreateUpdateRequestDtoToJSON(value?: IncomeTypeCreateUpdateRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
  };
}
